// ./client/src/types/courseDomains.js

export const CourseDomains = {

    IoT: {
        canvasLayout: 'horizontal',
        simulationMode: 'realtime',
        outputType: 'schematic',
        polling: {
            baseInterval:    2500,
            loopDelayBuffer: 500,
            cap:             21,
        },
        snapshotShape: {
            timestamp:      null,
            sensors:        {},
            actuatorStates: {},
        },
        runtimeFields: [
            { field: 'serialOutput',          default: [] },
            { field: 'serialInput',           default: [] },
            { field: 'simulationSnapshots',   default: [] },
            { field: 'codeValidationResults', default: [] },
        ],
        gradingPayloadFields: {
            serialOutput:             [],
            serialInput:              [],
            uploadedCode:             '',
            actuatorStates:           {},
            attachedSensors:          [],
            attachedActuators:        [],
            attachedDisplays:         [],
            simulationSnapshots:      [],
            codeValidationResults:    [],
            circuitValidationResults: [],
        },
        canvases: [
            {
                key: 'hardware',
                refKey: 'canvasRef1',
                header: 'Device Layer',
                subHeader: 'Physical Devices',
                icon: '🔧',
                output: 'schematic',
                emptyMessage: '🎨 Drag hardware components here',
                backgroundColor: '#ffffff',
                categories: [
                    { key: 'boards',           label: '🔷 Boards' },
                    { key: 'sensors',          label: '🌡️ Sensors' },
                    { key: 'actuators',        label: '⚡ Actuators' },
                    { key: 'displays',         label: '🖥️ Displays' },
                    { key: 'modules',          label: '🔌 Modules' },
                    { key: 'power',            label: '🔋 DC Power Supplies' },
                    { key: 'components',       label: '🔧 Components' },
                    { key: 'security_device',  label: '🔐 Security Device' },
                    { key: 'plc',              label: '🏭 PLCs & Field Devices' },
                ],
            },
            {
                key: 'bridge',
                refKey: 'canvasRef3',
                header: 'Network Layer',
                icon: '📡',
                emptyMessage: '📡 Drag communication protocols here',
                backgroundColor: '#fffbeb',
                categories: [
                    { key: 'communication',  label: '🤝 Communication Protocols' },
                    { key: 'edge_computing', label: '🕸️ Edge Computing' },
                ],
            },
            {
                key: 'cloud',
                refKey: 'canvasRef2',
                header: 'Cloud Layer',
                subHeader: 'Azure Services',
                icon: '☁️',
                emptyMessage: '☁️ Drag cloud services here',
                backgroundColor: '#f0f7ff',
                categories: [
                    { key: 'azure_iot',           label: '☁️ Azure IoT' },
                    { key: 'azure_analytics',     label: '📊 Azure Analytics' },
                    { key: 'azure_storage',       label: '💾 Azure Storage' },
                    { key: 'azure_visualization', label: '📈 Azure Visualization' },
                ],
            },
        ],
        configModal: {
            protocolTabLabel:      '📡 Protocols',
            pinTabLabel:           '🔌 Software Pins',
            showWireless:          true,
            protocolSectionTitle:  'Communication Protocols',
            pinSectionTitle:       'Software Pin Configuration',
            emptyProtocolMessage:  'No communication protocols available',
            emptyPinMessage:       'This component does not have software pins',
        },
        validation: {
            filters: [
                { key: 'connections',   label: 'Connections' },
                { key: 'protocols',     label: 'Protocols' },
                { key: 'i2cAddresses',  label: 'I2C Conflicts' },
                { key: 'dependencies',  label: 'Dependencies' },
                { key: 'configuration', label: 'Configuration' },
            ],
            successMessages: [
                '✅ All power connections: OK',
                '✅ All ground connections: OK',
                '✅ No floating pins detected',
                '✅ Circuit is ready to sync!',
            ],
        },
        wireTypes: [
            { value: 'power',  label: '⚡ Power' },
            { value: 'ground', label: '⏚ Ground' },
            { value: 'signal', label: '📡 Signal' },
            { value: 'data',   label: '💾 Data (I2C/SPI)' },
        ],
        reportTitle:   '📡 IoT Lab Report',
        gradingTitle:  '📡 Lab Grading',
        reportTabs: [
            { id: 'overview',           label: '📊 Overview' },
            { id: 'snapshots',          label: '📸 Snapshots' },
            { id: 'serial',             label: '🖥️ Serial Monitor' },
            { id: 'code',               label: '💻 Code' },
            { id: 'code-validation',    label: '🔍 Code Validation' },
            { id: 'circuit-validation', label: '🔌 Circuit Validation' },
        ],
        configureButtonTooltip: 'Configure Protocols, Wireless & Software Pins',
        buttonTitle:            '🔧 My IoT Circuits',
        simulator:              'simulator',
        simulatorLabel:         '▶️ 3. Simulate',
        simulatorIcon:          '🖥️ ',
        simulatorButtonLabel:   'Open Simulator',
        simulatorTooltip:       'Open Simulator',
    },

    IIoT: {
        canvasLayout: 'horizontal',
        simulationMode: 'realtime',
        outputType: 'schematic',
        polling: {
            baseInterval: 2000,
            cap:          20,
        },
        snapshotShape: {
            timestamp:      null,
            sensorText:     {},
            actuatorStates: {},
            plcToGateway: {
                protocol:  '',
                formatted: '',
            },
            gatewayToAzure: {
                protocol:  '',
                formatted: '',
            },
            azureDecoded: {},
            nodeLastData: {},
        },
        runtimeFields: [
            { field: 'simulationSnapshots',   default: [] },
            { field: 'codeValidationResults', default: [] },
        ],
        // Must match server/types/CourseDomains.ts IIoT.gradingPayloadFields exactly.
        // Used by simulationReport.jsx to extract evidenceData from gradingResult.
        gradingPayloadFields: {
            flowNodes:                [],
            flowWires:                [],
            flowStats:                {},
            gatewayConfig:            {},
            simulationSnapshots:      [],
            codeValidationResults:    [],
            circuitValidationResults: [],
        },
        canvases: [
            {
                key: 'hardware',
                refKey: 'canvasRef1',
                header: 'Device Layer',
                subHeader: 'Physical Devices',
                icon: '🔧',
                output: 'schematic',
                output: 'none',
                emptyMessage: '🎨 Drag hardware components here',
                backgroundColor: '#ffffff',
                categories: [
                    { key: 'boards',           label: '🔷 Boards' },
                    { key: 'sensors',          label: '🌡️ Sensors' },
                    { key: 'actuators',        label: '⚡ Actuators' },
                    { key: 'displays',         label: '🖥️ Displays' },
                    { key: 'modules',          label: '🔌 Modules' },
                    { key: 'power',            label: '🔋 DC Power Supplies' },
                    { key: 'components',       label: '🔧 Components' },
                    { key: 'security_device',  label: '🔐 Security Device' },
                    { key: 'plc',              label: '🏭 PLCs & Field Devices' },
                ],
            },
            {
                key: 'bridge',
                refKey: 'canvasRef3',
                header: 'Network Layer',
                icon: '📡',
                emptyMessage: '📡 Drag communication protocols here',
                backgroundColor: '#fffbeb',
                categories: [
                    { key: 'communication',  label: '🤝 Communication Protocols' },
                    { key: 'edge_computing', label: '🕸️ Edge Computing' },
                ],
            },
            {
                key: 'cloud',
                refKey: 'canvasRef2',
                header: 'Cloud Layer',
                subHeader: 'Azure Services',
                icon: '☁️',
                emptyMessage: '☁️ Drag cloud services here',
                backgroundColor: '#f0f7ff',
                categories: [
                    { key: 'azure_iot',           label: '☁️ Azure IoT' },
                    { key: 'azure_analytics',     label: '📊 Azure Analytics' },
                    { key: 'azure_storage',       label: '💾 Azure Storage' },
                    { key: 'azure_visualization', label: '📈 Azure Visualization' },
                ],
            },
        ],
        subCanvas: {
            domain:      'NodeRed',
            sessionKey:  'flowSessionId',
            modalTitle:  '🔴 Node-RED Flow Editor',
            description: 'Open the flow canvas in a new tab to drag and drop Node-RED nodes and build your IIoT data pipeline.',
            openLabel:   '🔴 Open Flow Canvas',
            accentColor: '#8F0000',
        },
        configModal: {
            protocolTabLabel:     '⚙️ Node Configuration',
            pinTabLabel:          '🔌 Port Settings',
            showWireless:         false,
            protocolSectionTitle: 'Node Configuration',
            pinSectionTitle:      'Port Configuration',
            emptyProtocolMessage: 'No configuration available for this node',
            emptyPinMessage:      'This node does not have configurable ports',
        },
        validation: {
            filters: [
                { key: 'connections',    label: 'Connections' },
                { key: 'protocols',      label: 'Protocols' },
                { key: 'i2cAddresses',   label: 'I2C Conflicts' },
                { key: 'configuration',  label: 'Configuration' },
                { key: 'flow_integrity', label: 'Flow Integrity' },
                { key: 'dependencies',   label: 'Dependencies' },
            ],
            successMessages: [
                '✅ All nodes connected: OK',
                '✅ All nodes configured: OK',
                '✅ Flow has valid input → output path',
                '✅ Flow is ready to deploy!',
            ],
        },
        wireTypes: [
            { value: 'nr_message', label: '📨 Message Wire' },
        ],
        reportTitle:  '🧠 IIoT Lab Report',
        gradingTitle: '🧠 IIoT Lab Grading',
        reportTabs: [
            { id: 'overview',           label: '📊 Overview' },
            { id: 'snapshots',          label: '📸 Snapshots' },
            { id: 'dashboard',          label: '📓 Dashboard' },
            { id: 'code-validation',    label: '🔍 Code Validation' },
            { id: 'circuit-validation', label: '🧠 Pipeline Validation' },
        ],
        configureButtonTooltip: 'Configure Node & Port Settings',
        buttonTitle:            '🔴 My Node-RED Flows',
        simulator:              'node-red-dashboard',
        simulatorLabel:         '▶️ 3. Open Dashboard',
        simulatorIcon:          '🔴 ',
        simulatorButtonLabel:   'Open Dashboard',
        simulatorTooltip:       'Open Node-RED Dashboard',
    },

    NodeRed: {
        canvasLayout: 'vertical',
        subCanvasLoader: 'flow', 
        outputType: 'config',
        // Sub-canvas only — no simulationMode, no polling, no snapshotShape,
        // no runtimeFields. Never reaches a simulator page.
        canvases: [
            {
                key: 'flow',
                refKey: 'canvasRef1',
                header: 'Flow Canvas',
                subHeader: 'Node-RED Data Pipeline',
                icon: '🔴',
                output: 'config',
                emptyMessage: '🔴 Drag Node-RED nodes here to build your flow',
                backgroundColor: '#fff8f0',
                categories: [
                    { key: 'nr_input',      label: '📥 Input Nodes' },
                    { key: 'nr_processing', label: '⚙️ Processing Nodes' },
                    { key: 'nr_output',     label: '📤 Output Nodes' },
                    { key: 'nr_storage',    label: '💾 Storage Nodes' },
                    { key: 'nr_dashboard',  label: '🖥️ UI Nodes' },
                ],
            },
        ],
        configModal: {
            protocolTabLabel:     '⚙️ Node Configuration',
            pinTabLabel:          '🔌 Port Settings',
            showWireless:         false,
            protocolSectionTitle: 'Node Configuration',
            pinSectionTitle:      'Port Configuration',
            emptyProtocolMessage: 'No configuration available for this node',
            emptyPinMessage:      'This node does not have configurable ports',
        },
        validation: {
            filters: [
                { key: 'connections',    label: 'Connections' },
                { key: 'protocols',      label: 'Protocols' },
                { key: 'i2cAddresses',   label: 'I2C Conflicts' },
                { key: 'configuration',  label: 'Configuration' },
                { key: 'flow_integrity', label: 'Flow Integrity' },
                { key: 'dependencies',   label: 'Dependencies' },
            ],
            successMessages: [
                '✅ All nodes connected: OK',
                '✅ All nodes configured: OK',
                '✅ Flow has valid input → output path',
                '✅ Flow is ready to deploy!',
            ],
        },
        wireTypes: [
            { value: 'nr_message', label: '📨 Message Wire' },
        ],
        // reportTitle:  '🧠 NodeRed Lab Report',
        // gradingTitle: '🧠 NodeRed Lab Grading',
        // reportTabs: [
        //     { id: 'overview',           label: '📊 Overview' },
        //     { id: 'dashboard',          label: '📓 Dashboard' },
        //     { id: 'code-validation',    label: '🔍 Code Validation' },
        //     { id: 'circuit-validation', label: '🧠 Pipeline Validation' },
        // ],
        configureButtonTooltip: 'Configure Node & Port Settings',
        buttonTitle:            '🔴 My Node-RED Flows',
        // simulator:              'node-red-dashboard',
        // simulatorLabel:         '▶️ 3. Open Dashboard',
        // simulatorIcon:          '🔴 ',
        // simulatorButtonLabel:   'Open Dashboard',
        // simulatorTooltip:       'Open Node-RED Dashboard',
    },

    AI: {
        canvasLayout: 'vertical',
        simulationMode: 'local',
        executionContext: 'pyodide',
        outputType: 'config',
        // no polling, no snapshotShape — runs in Pyodide locally
        runtimeFields: [
            { field: 'codeValidationResults', default: [] },
        ],
        gradingPayloadFields: {
            cellOutputs:              [],
            cellsExecuted:            0,
            totalCells:               0,
            hasErrors:                false,
            stdoutSummary:            '',
            codeValidationResults:    [],
            circuitValidationResults: [],
        },
        canvases: [
            {
                key: 'training',
                refKey: 'canvasRef1',
                header: 'Training Canvas',
                subHeader: 'AI Training Workflow',
                icon: '🧠',
                output: 'config',
                output: 'microchip-code',
                emptyMessage: '🧠 Drag training nodes here',
                backgroundColor: '#f5f3ff',
                categories: [
                    { key: 'data',          label: '📄 Data' },
                    { key: 'preprocessing', label: '🔀 Preprocessing' },
                    { key: 'model',         label: '🧠 Model' },
                    { key: 'training',      label: '🔄 Training' },
                ],
            },
            {
                key: 'test',
                refKey: 'canvasRef2',
                header: 'Test Canvas',
                subHeader: 'AI Test Workflow',
                icon: '🧪',
                emptyMessage: '🧪 Drag evaluation nodes here',
                backgroundColor: '#f0fdf4',
                categories: [
                    { key: 'evaluation', label: '🎯 Evaluation' },
                    { key: 'output',     label: '🖨️ Output' },
                ],
            },
        ],
        configModal: {
            protocolTabLabel:     '⚙️ Configuration',
            pinTabLabel:          '🔗 Data Pins',
            showWireless:         false,
            protocolSectionTitle: 'Component Configuration',
            pinSectionTitle:      'Data Pin Configuration',
            emptyProtocolMessage: 'No configuration available',
            emptyPinMessage:      'This component does not have data pins',
        },
        validation: {
            filters: [
                { key: 'connections',   label: 'Connections' },
                { key: 'pipeline',      label: 'Pipeline Order' },
                { key: 'configuration', label: 'Configuration' },
            ],
            successMessages: [
                '✅ Pipeline connections: OK',
                '✅ All stages configured: OK',
                '✅ No missing pipeline stages',
                '✅ Pipeline is ready to run!',
            ],
        },
        wireTypes: [
            { value: 'ai_data',    label: '🔗 Data Flow' },
            { value: 'model_data', label: '🧠 Model Data' },
            { value: 'evaluation', label: '🎯 Evaluation' },
            { value: 'output',     label: '🖨️ Output' },
        ],
        reportTitle:  '🧠 AI Lab Report',
        gradingTitle: '🧠 AI Lab Grading',
        reportTabs: [
            { id: 'overview',           label: '📊 Overview' },
            { id: 'notebook',           label: '📓 Notebook' },
            { id: 'code-validation',    label: '🔍 Code Validation' },
            { id: 'circuit-validation', label: '🧠 Pipeline Validation' },
        ],
        configureButtonTooltip: 'Configure Component & Data Pins',
        notebookTitle:          '🧠 AI Notebook',
        buttonTitle:            '🧠 My AI Pipelines',
        simulator:              'notebook',
        simulatorLabel:         '▶️ 3. Run Notebook',
        simulatorIcon:          '📓 ',
        simulatorButtonLabel:   'Open Notebook',
        simulatorTooltip:       'Open AI Notebook',
    },

    AgenticAI: {
        canvasLayout: 'vertical',
        simulationMode: 'local',
        executionContext: 'nodejs',
        outputType: 'config',
        // No polling, no snapshotShape.
        // Cells display Python code (industry standard) but execute via JavaScript
        // in the browser through the Node.js backend proxy — which injects OpenAI
        // and Pinecone API keys server-side. Students never see or handle keys.
        // Each cell stores both pythonCode (displayed) and javascriptCode (executed).
        runtimeFields: [
            { field: 'codeValidationResults', default: [] },
            {
                field:   'notebookCells',
                resetFn: (cells) => cells.forEach((c) => {
                    c.simOutputs     = {};
                    c.executionCount = 0;
                }),
            },
        ],
        // Must mirror server/types/CourseDomains.ts AgenticAI.gradingPayloadFields exactly.
        gradingPayloadFields: {
            cellOutputs:              [],
            cellsExecuted:            0,
            totalCells:               0,
            hasErrors:                false,
            stdoutSummary:            '',
            agentNodesExecuted:       [],
            graphCompiled:            false,
            ragRetrieved:             false,
            memoryTiersUsed:          [],
            toolCallsMade:            0,
            codeValidationResults:    [],
            circuitValidationResults: [],
        },
        canvases: [
            {
                key:             'build',
                refKey: 'canvasRef1',
                header:          'Build Canvas',
                subHeader:       'Agentic System Design',
                icon:            '🤖',
                output: 'config',
                output:          'microchip-code',
                emptyMessage:    '🤖 Drag agentic AI components here',
                backgroundColor: '#f5f3ff',
                categories: [
                    { key: 'foundation', label: '🧱 Foundation'  },
                    { key: 'chain',      label: '🔗 LangChain'   },
                    { key: 'rag',        label: '📚 RAG Pipeline' },
                    // NOTE: 'graph' has NO hasSubCanvas/subCanvasKey here.
                    // The LangGraph sub-canvas is opened by the AG_GRAPH_BUILDER
                    // component (isFlowEngine: true) — same pattern as IIoT gateway
                    // opening NodeRed. This is consistent with the existing architecture.
                    { key: 'graph',      label: '🕸️ LangGraph'   },
                ],
            },
            {
                key:             'deploy',
                refKey: 'canvasRef2',
                header:          'Deploy Canvas',
                subHeader:       'Tools, Memory & Output',
                icon:            '🚀',
                emptyMessage:    '🚀 Drag tools, memory and output nodes here',
                backgroundColor: '#f0fdf4',
                categories: [
                    { key: 'tools',  label: '🛠️ Tools'  },
                    { key: 'memory', label: '🧠 Memory'  },
                    { key: 'output', label: '🖨️ Output'  },
                    // 'api' (FastAPI / SSE) intentionally excluded —
                    // reserved for the future AI API & Deployment course.
                ],
            },
        ],
        subCanvas: {
            domain:           'LangGraph',
            sessionKey:       'graphSessionId',
            modalTitle:       '🕸️ LangGraph Graph Builder',
            description:      'Open the Graph Canvas in a new tab to drag and drop LangGraph nodes, wire edges, and define conditional routing for your agentic AI system.',
            openLabel:        '🕸️ Open Graph Canvas',
            accentColor:      '#7C3AED',
            // Categories whose components count as "nodes" in the stats panel.
            statCategories:   ['graph_nodes', 'graph_edges'],
        },
        configModal: {
            protocolTabLabel:     '⚙️ Configuration',
            pinTabLabel:          '🔗 Data Pins',
            showWireless:         false,
            protocolSectionTitle: 'Component Configuration',
            pinSectionTitle:      'Data Pin Configuration',
            emptyProtocolMessage: 'No configuration available',
            emptyPinMessage:      'This component does not have data pins',
        },
        validation: {
            filters: [
                { key: 'connections',   label: 'Connections'   },
                { key: 'pipeline',      label: 'Pipeline Order' },
                { key: 'configuration', label: 'Configuration'  },
                { key: 'graph',         label: 'Graph Wiring'   },
            ],
            successMessages: [
                '✅ Pipeline connections: OK',
                '✅ All components configured: OK',
                '✅ Graph nodes and edges: OK',
                '✅ Agentic pipeline ready to run!',
            ],
        },
        wireTypes: [
            { value: 'agent_data',  label: '🔗 Agent Data Flow' },
            { value: 'state_flow',  label: '🕸️ State Flow'      },
            { value: 'rag_context', label: '📚 RAG Context'     },
            { value: 'tool_call',   label: '🛠️ Tool Call'       },
            { value: 'memory_flow', label: '🧠 Memory Flow'     },
        ],
        reportTitle:  '🤖 Agentic AI Lab Report',
        gradingTitle: '🤖 Agentic AI Lab Grading',
        reportTabs: [
            { id: 'overview',           label: '📊 Overview'           },
            { id: 'notebook',           label: '📓 Notebook'           },
            { id: 'code-validation',    label: '🔍 Code Validation'    },
            { id: 'circuit-validation', label: '🕸️ Pipeline Validation' },
        ],
        configureButtonTooltip: 'Configure Component & Data Pins',
        notebookTitle:          '🤖 Agentic AI Notebook',
        buttonTitle:            '🤖 My Agentic Pipelines',
        simulator:              'notebook',
        simulatorLabel:         '▶️ 3. Run Notebook',
        simulatorIcon:          '📓 ',
        simulatorButtonLabel:   'Open Notebook',
        simulatorTooltip:       'Open Agentic AI Notebook',
    },

    // ─────────────────────────────────────────────────────────────────────────
    // LangGraph — sub-canvas only.
    // Mirrors NodeRed exactly:
    //   - No simulationMode, no polling, no snapshotShape, no runtimeFields.
    //   - Never reaches a simulator page on its own.
    //   - Opened when a component with isFlowEngine: true (AG_GRAPH_BUILDER)
    //     is placed on the AgenticAI Build Canvas — same trigger as IIoT
    //     gateway component opening NodeRed.
    // ─────────────────────────────────────────────────────────────────────────
    LangGraph: {
        canvasLayout: 'vertical',
        subCanvasLoader: 'graph',
        outputType: 'config',
        canvases: [
            {
                key:             'graph_wiring',
                refKey: 'canvasRef1',
                header:          'Graph Canvas',
                subHeader:       'LangGraph Node Wiring',
                icon:            '🕸️',
                emptyMessage:    '🕸️ Drag graph nodes and edges here to wire your agent',
                backgroundColor: '#fdf4ff',
                categories: [
                    { key: 'graph_nodes', label: '📦 Graph Nodes'    },
                    { key: 'graph_edges', label: '↔️ Edges & Routing' },
                ],
            },
        ],
        configModal: {
            protocolTabLabel:     '⚙️ Configuration',
            pinTabLabel:          '🔗 Data Pins',
            showWireless:         false,
            protocolSectionTitle: 'Node Configuration',
            pinSectionTitle:      'State Pin Configuration',
            emptyProtocolMessage: 'No configuration available for this node',
            emptyPinMessage:      'This node does not have state pins',
        },
        validation: {
            filters: [
                { key: 'connections',   label: 'Connections'  },
                { key: 'graph',         label: 'Graph Wiring' },
                { key: 'configuration', label: 'Configuration' },
            ],
            successMessages: [
                '✅ Graph node connections: OK',
                '✅ All nodes configured: OK',
                '✅ Conditional edges have valid branches: OK',
                '✅ Graph is ready to compile!',
            ],
        },
        wireTypes: [
            { value: 'state_flow', label: '🕸️ State Flow' },
        ],
        configureButtonTooltip: 'Configure Node & State Pins',
        buttonTitle:            '🕸️ My LangGraph Flows',
    },

};

/**
 * Merges backend-authoritative fields (simulationMode, polling, 
 * snapshotShape, sessionLabel) into the local CourseDomains object.
 * Called once by GlobalProvider on mount.
 */
export const mergeBackendDomains = (backendData) => {
  Object.entries(backendData).forEach(([domain, backendConfig]) => {
    if (CourseDomains[domain]) {
      Object.assign(CourseDomains[domain], backendConfig);
    }
  });
};

export const isHardwareDomain = (domain) => 
    CourseDomains[domain]?.canvasLayout === 'horizontal' &&
    (CourseDomains[domain]?.canvases?.length ?? 0) >= 3;

export default CourseDomains;